import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class ImageSortableController extends Controller {
  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      // 削除ボタンをドラッグの起点にせず、クリックはそのまま通す
      filter: ".photo-preview__delete",
      preventOnFilter: false,
    });
  }

  disconnect() {
    this.sortable.destroy();
  }
}
